// extracted by mini-css-extract-plugin
export default {"root":"styles_root__oDOkF","center":"styles_center__dZYRn","icon":"styles_icon__SC488","overlay":"styles_overlay__J3Tjr"};